<div class="card-bottom">
  <div *ngIf="cardData?.body?.has_benefits" class="benefits">
    <h4>
      <mat-icon svgIcon="exclusive-benefits" />
      <span>{{ 'Dining:ExclusiveBenefitsHeader' | translate }}</span>
    </h4>
    <p [innerHTML]="cardData?.body?.benefit | safeHtml"></p>
  </div>
  <section>
    <ten-card-booking-cta [availabilityStatus]="cardData?.availabilityStatus"></ten-card-booking-cta>
  </section>
</div>
